import { render, staticRenderFns } from "./Positioning.vue?vue&type=template&id=c6c29762&scoped=true&"
import script from "./Positioning.vue?vue&type=script&lang=js&"
export * from "./Positioning.vue?vue&type=script&lang=js&"
import style0 from "./Positioning.vue?vue&type=style&index=0&id=c6c29762&prod&scoped=true&lang=css&"
import style1 from "./Positioning.vue?vue&type=style&index=1&id=c6c29762&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c29762",
  null
  
)

export default component.exports